import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Home from "../pages/home";
import { useEffect } from "react";
import PageNotFound from "../components/pageNotFound";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyPolicy from "../pages/privacyPolicy";
import ContactUs from "../pages/contactUs";
import UserDelete from "../pages/userDelete";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (hash && pathname === "/") {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else if (hash && pathname !== "/") {
      navigate(`/${hash}`);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, navigate]);
  return null;
};

const PageTitleManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let pageTitle = "Hitch";

    switch (pathname) {
      case "/":
        pageTitle = "Hitch";
        break;
      case "/privacy-policy":
        pageTitle = "Privacy Policy | Hitch";
        break;
      case "/terms-conditions":
        pageTitle = "Terms & Conditions | Hitch";
        break;
      case "/contact-us":
        pageTitle = "Contact Us | Hitch";
        break;
      case "/user-delete":
        pageTitle = "Delete Account | Hitch";
        break;
      default:
        pageTitle = "Page Not Found | Hitch";
        break;
    }

    document.title = `${pageTitle}`;
  }, [pathname]);

  return null;
};

const AppRoutes = () => (
  <>
    <ScrollToTop />
    <PageTitleManager />

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/user-delete" element={<UserDelete />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </>
);
export default AppRoutes;
